import React, { PureComponent } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import { getClient, saveAnonymousToken, getQuote } from '../../store/actions';
import qs from 'qs';
import PropTypes from 'prop-types';
import * as analytics from '../../services/analytics';

const propTypes = {
  getQuote: PropTypes.func,
  saveAnonymousToken: PropTypes.func,
};

class AuthClientView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      redirectUrl: null,
    };
  }

  componentDidMount() {
    const query = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    analytics.track('Broker Portal - Client Auth Started');
    this.props.saveAnonymousToken(query.token);

    this.props
      .getQuote(query.quote_number)
      .then((quote) => {
        analytics.track('Broker Portal - Client Auth Get Quote Succeeded', {
          prepared: !!quote.application.plan_id,
        });
        return new Promise((resolve, reject) => {
          this.props
            .getClient(quote.client.id)
            .then(() => resolve(quote), reject);
        });
      })
      .then((quote) => {
        analytics.track('Broker Portal - Client Auth Get Client Succeeded');
        delete query.token;
        switch (quote.vertical_code) {
          case 'chubb_passport360':
            let redirectPassportQuery = query;
            let redirectPassportUrl = '/products/passport360';

            if (quote.application.plan_id) {
              redirectPassportQuery = { finalize: true };
              redirectPassportUrl = `/products/passport360/enroll/${quote.quote_number}/checkout`;
            }

            this.setState({
              redirectUrl: `${redirectPassportUrl}?${qs.stringify(
                redirectPassportQuery
              )}`,
            });
            break;
          case 'chubb_boa':
            let redirectBOAQuery = query;
            let redirectBOAUrl = '/products/boa';

            if (quote.application.plan_id) {
              redirectBOAQuery = { finalize: true };
              redirectBOAUrl = `/products/boa/enroll/${quote.quote_number}/checkout`;
            }

            this.setState({
              redirectUrl: `${redirectBOAUrl}?${qs.stringify(
                redirectBOAQuery
              )}`,
            });
            break;
          default:
            this.setState({
              redirectUrl: '/', // TODO: Invalid vertical code
            });
            break;
        }
      })
      .catch((error) => {
        analytics.track('Broker Portal - Client Auth Failed');
        this.setState({
          redirectUrl: '/', // TODO: Invalid route
        });
      });
  }

  render() {
    if (this.state.redirectUrl) {
      return <Redirect to={this.state.redirectUrl} />;
    } else {
      return null;
    }
  }
}

AuthClientView.propTypes = propTypes;

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveAnonymousToken,
      getClient,
      getQuote,
    },
    dispatch
  );

const enhance = compose(withRouter, connect(null, mapDispatchToProps));

export default enhance(AuthClientView);
